<template>
    <div class="w-full md:w-1/3 lg:w-2/7 mb-6 lg:mb-0">
        <a :href="href"
           :title="title"
           class="group text-center block js-project focus:outline-none"
           @mouseenter="scrollScreenToBottom"
           @mouseleave="scrollScreenToTop"
           @focusin="scrollScreenToBottom"
           @focusout="scrollScreenToTop">
            <div class="rounded-lg bg-white w-64 shadow-card pt-3 pb-3 px-4 mx-auto mb-6 group-hover:shadow-cardHigh">
                <div class="bg-gray-300 rounded-full h-2 w-2 mb-3 mx-auto"></div>
                <div class=" bg-gray-600 rounded-sm h-72 mb-3 border border-gray-200 overflow-y-hidden"
                     ref="ipad">
                    <div class="w-full relative duration-1000 top-0"
                         style="transition-timing-function:cubic-bezier(.47,.66,.73,.35)"
                         ref="screen">
                        <img :src="src"
                             :alt="title"
                             class="w-full"/>
                    </div>
                </div>
                <div class="rounded-full group-hover:bg-gray-100 duration-100 w-4 h-4 flex items-center justify-center border-gray-300 border mx-auto">
                    <div class="border-gray-300 border rounded-sm h-2 w-2"></div>
                </div>
            </div>

            <span class="text-blue-700 opacity-25 duration-100 group-hover:opacity-100 group-focus:opacity-100 font-semibold">{{ title }}</span>
            <svg class="stroke-current duration-100 group-hover:text-blue-700 group-focus:text-blue-700 text-gray-200 h-4 mx-auto mt-3"
                 viewBox="0 0 70 21"
                 fill="none"
                 xmlns="http://www.w3.org/2000/svg">
                <rect y="15"
                      width="63"
                      height="6"
                      fill="#FFD705"
                      stroke-width="0"
                      class="opacity-0 group-hover:opacity-100 group-focus:opacity-100 duration-100"/>
                <path d="M12.5 15H66L53 2"
                      stroke-width="3"/>
            </svg>

        </a>
    </div>
</template>

<script>
    export default {
        name: "projectDevice",
        props: ['src', 'title', 'href'],
        data: function() {
            return {}
        },
        methods: {
            scrollScreenToBottom() {
                this.$refs.screen.style.top = (0 - this.$refs.screen.clientHeight + this.screenHeight) + 'px';
            },
            scrollScreenToTop() {
                this.$refs.screen.style.top = 0;
            }
        },
        computed: {
            screenHeight: function() {
                return this.$refs.ipad.clientHeight;
            }
        }
    }
</script>
